
import axios from "axios";

// =======================
// ⚙️ ENVIRONMENT CONFIGURATION
// =======================
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.driveonyx.cloud/api";
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost5000/api";
// export const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || "http://localhost5000";
export const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || "https://api.driveonyx.cloud";

// 🔹 Centralized Axios Instance with proper config
const API = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 60000, // 60 seconds for large file uploads
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// =======================
// 🔐 AUTH APIs
// =======================

// Login
export const loginUser = (data) => API.post("/auth/login", data);

// Send OTP
export const sendOTP = (data) => API.post("/auth/send-otp", data);

// Verify OTP
export const verifyOTP = (data) => API.post("/auth/verify-otp", data);

// Reset Password
export const resetPassword = (data) =>
  API.post("/auth/reset-password", data);

// Get Current User
export const authMe = () => API.get("/auth/me");

// Logout
export const logoutUser = () => API.post("/auth/logout", {});

// =======================
// ✅ COMPLETE APIs
// =======================
export const completeCustomer = (data) =>
  API.post("/complete", data);



// =======================
// 🚗 CAR APIs (CRUD)
// =======================

// Get all cars
export const getCars = () => API.get("/cars");

// Add car
export const addCar = (data) => API.post("/cars", data);

// Update car
export const updateCar = (id, data) =>
  API.put(`/cars/${id}`, data);

// Delete car
export const deleteCar = (id) =>
  API.delete(`/cars/${id}`);



// =======================
// 👤 CUSTOMER APIs (File Upload)
// =======================

// Add customer with files
export const addCustomer = (data) =>
  API.post("/customers", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

// Get all customers
export const getCustomers = () => API.get("/customers");

export const updateCustomer = (id, data) =>
  API.put(`/customers/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const deleteCustomer = (id) =>
  API.delete(`/customers/${id}`);

// =======================
// ⚙️ REQUEST & RESPONSE INTERCEPTORS
// =======================

// Request Interceptor - Add Auth Token if exists
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor - Handle errors properly
API.interceptors.response.use(
  (res) => res,
  (err) => {
    // Network errors (no response from server)
    if (!err.response) {
      // Add custom code for network errors
      err.code = 'NETWORK_ERROR';
      console.error("Network Error:", err.message);
    }
    
    // Handle specific status codes
    if (err.response?.status === 401) {
      console.warn("Unauthorized - Session expired or invalid token");
      // Optional: Redirect to login on 401
      // window.location.href = "/login";
    }
    if (err.response?.status === 403) {
      console.warn("Forbidden - Access denied");
    }
    if (err.response?.status === 500) {
      console.error("Server error - Please contact support");
    }
    if (err.response?.status === 503) {
      console.error("Service unavailable - Server is down");
    }
    
    return Promise.reject(err);
  }
);

// 🔚 Export API (for direct use if needed)
export default API;